import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import userRegistration01 from "@/assets/images/help/user-registration-01.png";
import userRegistration02 from "@/assets/images/help/user-registration-02.png";
import userRegistration03 from "@/assets/images/help/user-registration-03.png";
import userRegistration04 from "@/assets/images/help/user-registration-04.png";
import userRegistration05 from "@/assets/images/help/user-registration-05.png";
import userRegistration06 from "@/assets/images/help/user-registration-06.png";

export default function HelpUserRegistration() {
  const navigate = useNavigate();

  const steps = [
    {
      title: "Step 1: Enter Account Information",
      description: "Enter your account email and password.",
      image: userRegistration01,
    },
    {
      title: "Step 2: Enter Personal Information",
      description: "Fill in your personal details including name and date of birth.",
      image: userRegistration02,
    },
    {
      title: "Step 3: Enter Identification Information",
      description: "Provide your identification number and related information.",
      image: userRegistration03,
    },
    {
      title: "Step 4: Enter Contact Information",
      description: "Enter your phone number and contact details.",
      image: userRegistration04,
    },
    {
      title: "Step 5: Verify Your Phone Number",
      description:
        " · Click the \"Send Code\" button to send a verification code to the phone number you entered.\n · Enter the code to complete phone number verification.",
      image: userRegistration05,
      note: "※ Each phone number can only be used for verification once.",
    },
    {
      title: "Step 6: Enter Business Information",
      description: "Provide your business or employment details.",
      image: userRegistration06,
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-6">
          <h1 className="text-2xl font-bold mb-2">
            User Verification Step 1: User Registration
          </h1>
          <p className="text-sm text-muted-foreground">
            Follow the instructions below to complete user registration.
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="space-y-4">
              <h3 className="text-lg font-bold opacity-90">{step.title}</h3>
              <p className="text-sm font-semibold whitespace-pre-line">
                {step.description}
              </p>
              <div className="rounded-lg overflow-hidden shadow-md">
                <img
                  src={step.image}
                  alt={`Step ${index + 1}`}
                  className="w-full h-auto"
                />
              </div>
              {step.note && (
                <p className="text-sm font-semibold text-muted-foreground">
                  {step.note}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Completion Note */}
        <div className="mt-8 p-4 bg-primary/5 rounded-lg">
          <h3 className="text-lg font-bold opacity-90 mb-2">
            Step 7: Complete Registration
          </h3>
          <p className="text-sm font-semibold">
            After filling in all the required fields, click the "Register"
            button to complete your user registration.
            {"\n\n"}
            Proceed to the next step.
          </p>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/4")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: Address Registration</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
